module.exports = __webpack_public_path__ + "img/jp-title.8123d3ca.png";